/**
 * Token storage for the browser build — deliberately stores nothing.
 *
 * The web session lives in HttpOnly cookies the page cannot read (see
 * `session-mode.web.ts`). There is therefore no pair to keep, and any store
 * that did keep one would be strictly worse than none: `localStorage` and
 * `sessionStorage` are both readable by any script that gets onto the page, and
 * a refresh token is a long-lived credential for someone's workplace.
 *
 * This file exists so nothing on the web path can reach for `react-native-
 * keychain`, whose browser stand-in could only ever be plaintext.
 */
/**
 * Declared here rather than imported from `tokens.ts`: on web that specifier
 * resolves back to this very file (`.web.ts` wins in resolve.extensions), so an
 * import would be circular. Kept structurally identical on purpose — the two
 * files are the same module seen by two bundlers.
 */
export type Tokens = {
  accessToken: string;
  refreshToken: string;
};

export async function saveTokens(_tokens: Tokens): Promise<void> {
  // Nothing to do: the gateway's Set-Cookie already put the session where the
  // browser keeps it.
}

export async function loadTokens(): Promise<Tokens | null> {
  // Not "no session" — "no session the page can see". Whether one exists is a
  // question only the server can answer, which is what auth-store's hydrate()
  // does by calling /auth/me.
  return null;
}

export async function clearTokens(): Promise<void> {
  // The cookies are cleared by the server on POST /auth/logout; a script has no
  // way to delete an HttpOnly cookie itself.
}
